module.exports = __webpack_public_path__ + "img/beetle_feelers_right.917bee37.png";